import { useContext, useEffect, useState } from 'react';
import VLCTable from '../../costConditionCreate/vlcSetup/table';
import { axios } from '../../../../../utils/axios';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { showAlert } from '../../../../../utils/alerts';
import { CostingRequestsContext } from '../../../../../contexts/CostingRequest';
import { NotificationModal } from '../../../../../components/modal/NotificationModal';
import { crRoles, notificationPopup } from '../../../../../constants';

const FobSetup = ({ activeTab, activeSubTab, logsModal, setLogsModal }) => {
  const { crNumber } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { isCrRoleAuthorized, info, crAssignedSpocs } = useContext(CostingRequestsContext);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const { producing_plant_data } = info;

  useEffect(() => {
    if (activeTab === 'tpSetup' && activeSubTab === 'fobSetup' && producing_plant_data.length > 0) {
      fetch();
    }
  }, [activeTab, activeSubTab, producing_plant_data]);

  const checkActive = (status, country, userType) => {
    const res =
      String(status).toLocaleLowerCase() === 'in progress' &&
      isCrRoleAuthorized(producing_plant_data[0].producing_country, crRoles.logistics_fpna_analyst);
    return res;
  };

  const checkActiveFpna = (status, country, value) => {
    const res =
      String(status).toLocaleLowerCase() === 'in progress' &&
      isCrRoleAuthorized(producing_plant_data[0].producing_country) &&
      (parseFloat(value) ? parseFloat(value) : 0.0) !== 0;

    return res ?? false;
  };

  const transformData = (data) => {
    const newData = data.map((ele) => {
      ele.sku = ele?.IntCrConditionRecordLogs?.[0]?.material;
      ele.sku_desc = ele?.IntCrConditionRecordLogs?.[0]?.material_description;
      ele.status = ele?.status || ele?.IntCrConditionRecordLogs?.[0]?.status;
      ele.sales_org = ele?.IntCrConditionRecordLogs?.[0]?.sales_org;
      ele.distribution_channel = ele?.IntCrConditionRecordLogs?.[0]?.distribution_channel;
      ele.condition_type = ele?.IntCrConditionRecordLogs?.[0]?.condition_type;
      ele.key_combination = ele?.IntCrConditionRecordLogs?.[0]?.key_combination;
      ele.costPerHL =
        parseFloat(ele?.IntCrConditionRecordLogs?.[0]?.cost_per_hl || 0).toFixed(4) || 0;
      ele.costPerHundred =
        parseFloat(ele?.IntCrConditionRecordLogs?.[0]?.cost_per_100hl || 0).toFixed(2) || 0;
      ele.currency = ele?.IntCrConditionRecordLogs?.[0]?.currency_key;
      ele.uom = ele?.IntCrConditionRecordLogs?.[0]?.unit_of_measure;
      ele.unit = ele?.IntCrConditionRecordLogs?.[0]?.per;
      ele.valid_from = moment(ele?.IntCrConditionRecordLogs?.[0]?.valid_from).isValid()
        ? moment(ele?.IntCrConditionRecordLogs?.[0]?.valid_from).format('DD-MM-YYYY')
        : null;
      ele.valid_to = moment(ele?.IntCrConditionRecordLogs?.[0]?.valid_to).isValid()
        ? moment(ele?.IntCrConditionRecordLogs?.[0]?.valid_to)
            .utc()
            .startOf('day')
            .format('DD-MM-YYYY')
        : null;
      ele.submittedOn = moment(ele?.IntCrConditionRecordLogs?.[0]?.createdAt).isValid()
        ? moment(ele?.IntCrConditionRecordLogs?.[0]?.createdAt).format('DD-MM-YYYY')
        : null;
      ele.completedOn = moment(ele?.IntCrConditionRecordLogs?.[0]?.completed_on).isValid()
        ? moment(ele?.IntCrConditionRecordLogs?.[0]?.completed_on).format('DD-MM-YYYY')
        : null;
      ele.fpna_gcc_sme = crAssignedSpocs(producing_plant_data[0].producing_country);
      ele.logisticsFpna = crAssignedSpocs(
        producing_plant_data[0].producing_country,
        crRoles.logistics_fpna_analyst,
      );
      return ele;
    });
    return newData;
  };
  const fetch = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`costing-request/step/fob_setup/${crNumber}`);
      const apiData = transformData(res?.data?.data);
      setData(apiData);
    } catch (e) {
      console.log('errorrr', e);
      showAlert(e, 'error');
    } finally {
      setLoading(false);
    }
  };
  const handleCostChange = (val, id) => {
    const correctVal = parseFloat(val || 0).toFixed(4) > 0.0;
    setData((prevData) =>
      prevData.map((ele) => {
        if (ele?.id === id) {
          if (correctVal) {
            ele.costPerHL = val;
          } else {
            ele.costPerHL = 0;
          }
        }
        return ele;
      }),
    );
  };
  const submitCostChange = async (val, id) => {
    setNotificationModalOpen(true);
    const costPerHl = val || 0;
    if (!(costPerHl > 0)) {
      showAlert({ message: 'Cost per HL must be greater than zero' }, 'error');
      return;
    }
    setLoading(true);
    const payload = {
      step_id: id,
      amount: costPerHl,
    };
    try {
      const res = await axios.post(`costing-request/step/fob_setup/${crNumber}`, payload);
      if (res?.data?.success) {
        showAlert({ message: 'Cost per HL updated' }, 'success');
      }
    } catch (e) {
      console.log(e);
      showAlert(e, 'error');
    } finally {
      await fetch();
      setLoading(false);
    }
  };
  const handleRefresh = async (id) => {
    setLoading(true);
    const payload = { step_id: id };
    try {
      const res = await axios.post(`costing-request/step/fob_setup/retry/${crNumber}`, payload);
      if (res?.success) {
        showAlert('', 'success');
      }
    } catch (e) {
      showAlert(e, 'error');
    } finally {
      await fetch();
      setLoading(false);
    }
  };
  return (
    <>
      <VLCTable
        handleRefresh={handleRefresh}
        data={data}
        handleCostChange={handleCostChange}
        loading={loading}
        logsModal={logsModal}
        setLogsModal={setLogsModal}
        logsHeader={'Fob Setup'}
        checkActive={checkActive}
        checkActiveFpna={checkActiveFpna}
        submitCostChange={submitCostChange}
        csvFilename={`fob_setup_${moment().format('YYYY-MM-DD')}`}
      />
      <NotificationModal
        notificationModalOpen={notificationModalOpen}
        setNotificationModalOpen={setNotificationModalOpen}
        notificationText={notificationPopup.text}
        title={notificationPopup.title}
      />
    </>
  );
};

export default FobSetup;
